
export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-4">
              <div className="flex items-baseline space-x-1">
                <div className="flex items-baseline">
                  <span className="text-2xl font-bold text-red-600" style={{fontFamily: 'Georgia, serif'}}>PGVH</span>
                  <span className="text-2xl font-bold text-white" style={{fontFamily: 'Georgia, serif'}}>armony</span>
                </div>
                <span className="text-sm text-white" style={{fontFamily: 'Georgia, serif'}}>F.Z.E.</span>
              </div>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Your trusted partner for international trade, specializing in educational toys, 
              electronic games, and hi-tech toys with reliable global shipping.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
            <div className="space-y-3">
              <button 
                onClick={() => scrollToSection('home')}
                className="block text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
              >
                Home
              </button>
              <button 
                onClick={() => scrollToSection('products')}
                className="block text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
              >
                Products
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="block text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
              >
                Contact
              </button>
              <button 
                onClick={() => scrollToSection('supplier')}
                className="block text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
              >
                Become Supplier
              </button>
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Our Products</h4>
            <div className="space-y-3">
              <p className="text-gray-300">Educational Toy</p>
              <p className="text-gray-300">Electronic Plastic Toy</p>
              <p className="text-gray-300">Hobby/Model Construction</p>
              <p className="text-gray-300">Electronic Games</p>
              <p className="text-gray-300">Hi-tech Toy</p>
              <p className="text-gray-300">Non-Electronic Plastic Toy</p>
            </div>
          </div>

        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2024 PGVHarmony F.Z.E Trading & Export Company. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <p className="text-gray-400 text-sm">Company founded in Ajman, Dubai branch</p>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
